<script lang="ts" setup>
import ConnectWalletBtn from '@/components/atoms/ConnectWalletBtn.vue';
import { useWallet } from 'solana-wallets-vue';
import { watch } from 'vue';
import { useRouter } from 'vue-router';
import AppSearch from '@/components/molecules/AppSearch.vue';

const router = useRouter();

const { connected, publicKey } = useWallet();

const goToPortfolio = () => {
  router.push({
    name: 'Portfolio',
    params: {
      addresses: publicKey.value?.toBase58(),
      bundleId: undefined,
    },
  });
};

watch(connected, () => {
  if (connected.value) {
    goToPortfolio();
  }
});
</script>

<template>
  <div
    class="h-full"
    style="
      background-image: url('/bg-home.jpg');
      background-size: cover;
      background-position: center;
    "
  >
    <div
      class="h-full flex flex-column gap-12 w-full bg-gradient-to-r from-black/10 via-black/80 to-black/10"
    >
      <div
        class="flex flex-column h-full items-center justify-center gap-8 p-12"
      >
        <div class="flex flex-col gap-2">
          <h1 class="text-6xl text-center font-extrabold">Jupiter Portfolio</h1>
          <p class="text-2xl text-center">
            Track all your assets, in one place.
          </p>
        </div>
        <div class="w-full max-w-[500px] flex flex-column gap-1 items-center">
          <app-search class="w-full"></app-search>
          <span class="text-white/80">or</span>
          <div class="flex flex-column items-center justify-center gap-2">
            <ConnectWalletBtn
              v-if="!connected"
              size="x-large"
              color="primary"
              variant="elevated"
            />
            <v-btn
              v-else
              @click="goToPortfolio"
              size="x-large"
              color="primary"
              variant="elevated"
              >Go to Portfolio</v-btn
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
